
import { defineComponent } from 'vue'
import Image from '@/components/Image.vue'
export default defineComponent({
  name: 'ProductUsers',
  components: {
    Image
  }
})
